module.exports = __webpack_public_path__ + "static/img/index_swiper.a5db7a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_swiper.jpg
// module id = lti/
// module chunks = 1